import { FeatureFlag } from '../FeatureFlag';

/**
 * Enables per-column filters on the TableModel-backed table widgets (ADR 0014, CC-008): header
 * filter buttons on string columns, the column editor, and the widget header summary of active
 * filters. Off means no column filter applies, even one set before the flag turned off
 * (AC-FILTER-009). LAB v2 Cost Info has its own flag.
 */
export const enableTableColumnFilters = new FeatureFlag({
    key: 'enable-table-column-filters',
    createdOn: '2026-10-22',
    defaultValue: false,
});
